import { useTranslation } from 'react-i18next';

import { OpportunityViewButton } from 'components';
import { useIframeLogin, getBonfireOpportunityPath } from '../../hooks/useIframeLogin';

// Any row that is not for the `following` type are guaranteed Bonfire
// opportunities (wip/submissions/awarded/missed/contracts are internal
// to Bonfire). Otherwise, `following` may contain external opportunities.
const formatRow = (type, row) =>
  type === 'following'
    ? {
        ...row,
        projectId: row.ProjectID,
        domain: row.Organization.Domain,
        organizationName: row.Organization.OrganizationName,
        externalLink: row.ExternalLink,
        isBonfireOrganization: row.Organization.IsBonfireOrganization,
      }
    : {
        ...row,
        externalLink: false,
        isBonfireOrganization: true,
      };

const getPathForRowType = (type, row) => {
  switch (type) {
    case 'wip':
    case 'submitted':
    case 'awarded':
    case 'missed':
      return `/submissions/${row.proposalId}`;
    case 'following':
      return row.isBonfireOrganization ? getBonfireOpportunityPath(row.projectId) : '';
    case 'contracts':
      return `/publicContracts/${row.id}`;
    default:
      throw new Error('Invalid type!');
  }
};

const DashboardDataTableLinkCell = ({ row, type }) => {
  const { t } = useTranslation();
  const { logInToOrganizationDomain, handleLoadGoToProjectIframe, iframeRef, iframeSrc } =
    useIframeLogin();

  const formattedRow = formatRow(type, row);
  const path = getPathForRowType(type, formattedRow);

  return (
    <>
      <OpportunityViewButton
        isBonfireOrganization={formattedRow.isBonfireOrganization}
        externalLink={formattedRow.externalLink}
        openBonfireOpportunity={() => {
          logInToOrganizationDomain(`https://${formattedRow.domain}`, path);
        }}
        size="small"
        label={t('dashboard.data_table.view')}
        variant="outline"
      />
      {iframeSrc && (
        <iframe
          style={{ display: 'none' }}
          ref={iframeRef}
          src={iframeSrc}
          onLoad={handleLoadGoToProjectIframe}
          title={t('dashboard.organization_iframe_title', {
            organization: formattedRow.organizationName,
          })}
          aria-hidden="true"
        />
      )}
    </>
  );
};

export default DashboardDataTableLinkCell;
